import { useEffect } from 'react'

import { clearChunkReloadGuardOnBoot } from './error/chunkErrorReload'
import { ErrorBoundary } from './error/ErrorBoundary'
import { TranslationProvider } from './i18n'
import { Router } from './router'
import Routes from './routes'
import ThemeProvider from './theme'
import { UpdatePrompt } from './utils/AppVersion'

export const App = () => {
  // The shell mounting is the unambiguous "boot succeeded" point, so a chunk
  // reload that got us here has done its job and must not stay spent for the
  // rest of the tab's life
  useEffect(() => clearChunkReloadGuardOnBoot(), [])

  return (
    <ThemeProvider>
      <ErrorBoundary>
        <TranslationProvider>
          <Router>{Routes}</Router>
          <UpdatePrompt />
        </TranslationProvider>
      </ErrorBoundary>
    </ThemeProvider>
  )
}
